import React, { useEffect, useState } from "react";
import {
  Grid,
  CircularProgress,
  Card,
  CardContent,
} from "@material-ui/core";
import { MdMail } from "react-icons/md";
import { MdPhoneAndroid } from "react-icons/md";
import { MdMarkunreadMailbox } from "react-icons/md";
import {
  GetEnterpriseData,
} from "../../services/EnterpriseDataCallsService";
import { Attributes } from "../../commons/Attributes";
import { CommonStyles } from "../../commons/CommonStyles";
import { Alerts } from "../Alerts/Alerts";
import { AttributesVerifiedCard } from "./components/AttributesVerifiedCard";
import { FaFilePdf } from "react-icons/fa";
import { checkIsNullUndefined, getErrorMessage } from "../../commons/Utils";
import { useTranslation } from "react-i18next";
import { controlUserMovement, getReplaceMode } from "../../services/Commons";
import { CorreosButton } from "../CorreosButton/CorreosButton";
import { CorreosIcon } from "../CommonComponents/CorreosIcon/CorreosIcon";
import { iconNames } from "../../commons/EnumsGeneral";

export function EnterpriseVerifications(props) {
  const { idEnterprise, getIsOrganization, getIsTitular } = props;
  const commonClasses = CommonStyles();
  const { t } = useTranslation();

  const [documentNum, setDocumentNum] = useState("");
  const [directions, setDirections] = useState([]);
  const [circularProgress, setCircularProgress] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    color: "",
    message: "",
  });
  const [openVerifiedPopper, setOpenVerifiedPopper] = useState(false);
  const [openNotVerifiedPopper, setOpenNotVerifiedPopper] = useState(false);
  const [isTitular, setIsTitular] = useState(false);

  useEffect(() => {
    // setIsOrganization(getIsOrganization());
    setIsTitular(getIsTitular() && !getIsOrganization());
    chargePageData();
  }, [idEnterprise]);

  const finishOperation = (color, message) => {
    setAlert({
      open: true,
      color,
      message,
    });
  };

  const chargePageData = () => {
    setCircularProgress(true);
    GetEnterpriseData(idEnterprise).then((response) => {
      if (response && !response.Status) {
        setDocumentNum([{ value: response.documentNumber }]);
        setDirections(response.enterpriseAddress);
        if (checkIsNullUndefined(response.documentNumber)) {
          finishOperation("error", t("teamPageNoDocumentEnterprise"));
        }
        setCircularProgress(false);
      } else {
        finishOperation("error", getErrorMessage(response, t));
        setCircularProgress(false);
      }
    });
  };

  const getIcon = (name) => {
    switch (name) {
      case Attributes.UserEmail:
        return <MdMail className={commonClasses.iconStyle} />;
      case Attributes.PersonaTelfMovil:
        return <MdPhoneAndroid className={commonClasses.iconStyle} />;
      case Attributes.PersonaNumDocID:
        return <CorreosIcon iconSelected={iconNames.document} iconName="Card Icon" iconState="basic" iconScale={"2.5"} />;
      case Attributes.PersonaDireccion:
        return <MdMarkunreadMailbox className={commonClasses.iconStyle} />;
      case Attributes.Documents:
        return <FaFilePdf className={commonClasses.iconStyle} />;
      default:
        break;
    }
  };

  return (
    <div
      onClick={
        openVerifiedPopper
          ? () => setOpenVerifiedPopper(false)
          : openNotVerifiedPopper
            ? () => setOpenNotVerifiedPopper(false)
            : null
      }
    >

      <Grid>
        <Alerts alert={alert} setAlert={setAlert}></Alerts>
        <Grid>
          <Grid container spacing={3}>
            <Grid item sm={6} container spacing={3}>
              {circularProgress ? (
                <CircularProgress />
              ) : (
                <Grid item xs={12}>
                  <Card>
                    <CardContent>
                      <AttributesVerifiedCard
                        documentNum={documentNum}
                        directions={directions}
                        getIcon={getIcon}
                        chargePageData={chargePageData}
                        finishOperation={finishOperation}
                        isTitular={isTitular}
                      />
                    </CardContent>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Grid>
          {getReplaceMode() == "true" ? (
            <Grid container spacing={1} style={{ marginTop: "1.5em" }}>
              <Grid item xs={12}>
                <CorreosButton
                  onClick={() => { controlUserMovement(false, finishOperation, t) }}
                  variant="contained"
                  color="primary"
                  className={commonClasses.dialogButtonCenter}
                >
                  {t("backToTheApp")}
                </CorreosButton>
              </Grid>
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    </div>
  );
}
